import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';
// Social media icons import removed
import styled from 'styled-components';

const StyledFooter = styled.footer`
  background-color: #124116;
  color: #fff;
  padding: 70px 0 0;
  position: relative;
  
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(to right, #ff9800, #2e7d32);
  }
  
  h5 {
    color: #fff;
    font-weight: 700;
    margin-bottom: 20px;
    font-size: 1.2rem;
    position: relative;
    padding-bottom: 15px;
    
    &:after {
      content: '';
      position: absolute;
      left: 0;
      bottom: 0;
      width: 50px;
      height: 2px;
      background-color: #ff9800;
    }
  }
  
  .footer-links {
    list-style: none;
    padding: 0;
    margin: 0;
    
    li {
      margin-bottom: 12px;
      
      a {
        color: #ccc;
        text-decoration: none;
        transition: all 0.3s ease;
        display: inline-block;
        
        &:hover {
          color: #ff9800;
          transform: translateX(5px);
        }
      }
    }
  }
  
  .contact-info {
    margin-bottom: 10px;
    display: flex;
    align-items: flex-start;
    
    svg {
      color: #ff9800;
      margin-right: 10px;
      margin-top: 4px;
    }
  }
  
  .social-links {
    display: flex;
    gap: 15px;
    margin-top: 20px;
    
    a {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      background-color: rgba(255, 255, 255, 0.1);
      color: #fff;
      border-radius: 50%;
      transition: all 0.3s ease;
      
      &:hover {
        background-color: #ff9800;
        transform: translateY(-3px);
      }
    }
  }
  
  .footer-bottom {
    background-color: rgba(0, 0, 0, 0.2);
    margin-top: 50px;
    padding: 20px 0;
    text-align: center;
    font-size: 0.9rem;
    
    a {
      color: #ff9800;
      text-decoration: none;
    }
  }
`;

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <StyledFooter>
      <Container>
        <Row className="gy-4">
          {/* About Us section removed as requested */}
          <Col lg={2} md={6}>
            <h5>Quick Links</h5>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/how-it-works">How It Works</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/faq">FAQ</Link></li>
            </ul>
          </Col>
          <Col lg={2} md={6}>
            <h5>Legal</h5>
            <ul className="footer-links">
              {/* Blog and Testimonials links removed as requested */}
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/terms-conditions">Terms & Conditions</Link></li>
            </ul>
          </Col>
          <Col lg={4} md={6}>
            <h5>Contact Us</h5>
            <div className="contact-info">
              <FontAwesomeIcon icon={faMapMarkerAlt} />
              <div>
                <p>14 NE 1st Ave Ste 1403 #140<br />Miami, FL 33132</p>
              </div>
            </div>
            <div className="contact-info">
              <FontAwesomeIcon icon={faPhone} />
              <div>
                <p>786-460-6046</p>
              </div>
            </div>
            <div className="contact-info">
              <FontAwesomeIcon icon={faEnvelope} />
              <div>
                <p>connect@beringsolutions.com</p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      <div className="footer-bottom">
        <Container>
          <p>© {currentYear} Bering Solutions, LLC. All Rights Reserved | <Link to="/sitemap">Sitemap</Link></p>
        </Container>
      </div>
    </StyledFooter>
  );
};

export default Footer;
